<script>

    import { toast } from 'bulma-toast'
    import { usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputPassword from '../$components/input.password.svelte'

    let loading = false
    let data = {}

    async function createUser() {

        loading = true
        const resp = await UsersService.createUser(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        usersStore.append(resp.data)

        toast({message: 'Usuario registrado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={createUser} { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={data.role}
                label="Rol"
                options={[
                    {value: 'user', text: 'User'},
                    {value: 'admin', text: 'Administrador'},
                    {value: 'support', text: 'Soporte'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.firstName} label="Nombre" placeholder="Nombre" />
        </div>
        <div class="column">
            <InputText bind:value={data.lastName} label="Apellidos" placeholder="Apellidos" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.corporate} label="Empresa" placeholder="Empresa" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.phone} label="Teléfono" placeholder="Teléfono" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.email} label="Correo" placeholder="Correo" />
        </div>
        <div class="column">
            <InputPassword bind:value={data.password} label="Contraseña" placeholder="Contraseña" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading}/>
        </div>
    </div>
</Form>